import { render, staticRenderFns } from "./info.vue?vue&type=template&id=11c8f2b1&lang=pug&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c8f2b1')) {
      api.createRecord('11c8f2b1', component.options)
    } else {
      api.reload('11c8f2b1', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=11c8f2b1&lang=pug&", function () {
      api.rerender('11c8f2b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/payment/info.vue"
export default component.exports